/* eslint-disable no-param-reassign */
import { Tweens as ABCyaTweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class BlobBase extends Phaser.GameObjects.Container {

  constructor (scene, row, col, direction) {
    super(scene);
  }

  rotate() {

    this.direction += 1;
    if (this.direction > 3) {
      this.direction = 0;
    }

    let angle = 0;

    switch (this.direction) {

      case -1:
      case 0:
      case 6:
        angle = 359;
        break;

      case 1:
        angle = 90;
        break;

      case 2:
        angle = 180;
        break;

      case 3:
        angle = 270;
        break;
    }

    angle = this.angle + 90;

    ABCyaTweens.addTween(this, 500, { angle }, Phaser.Math.Easing.Linear);
  }

  oppositeDirection(direction) {

    direction += 1;
    if (direction > 3) {
      direction = 0;
    }

    direction += 1;
    if (direction > 3) {
      direction = 0;
    }

    return direction;

  }
}